import {useLocation, useRouteError} from "react-router-dom";
import ErrorPage from "./ErrorPage";
import NewDesignErrorPage from "@/custolink-newdesign/pages/ErrorPage";
import axios, {AxiosError} from "axios";
import handleAxiosError from "@/custolink-logic/api/handleAxiosError";
import {isNewDesign} from "@/custolink-newdesign/flag";
import {isAssetFrontendNewDesign} from "@/custolink-views/asset_frontend/redesigns/assetFrontendDesign";

function extractErrorMessage(error: unknown): string {
  if (error instanceof Error) {
    if (axios.isAxiosError(error)) {
      const errorHandled = handleAxiosError(error as AxiosError)
      return errorHandled.errorMessage
    }
    return error.message
  }
  return JSON.stringify(error)
}

// Used as the errorElement for both /admin routes and the public asset-frontend
// routes (OrganisationAllRoutes.tsx), so the design switch it consults has to match
// whichever side the error happened on - the admin switch under /admin (org admin
// area and the cp.* control panel, both at /admin), the asset-frontend switch
// everywhere else. See RouteNotFound.tsx for the same split.
export default function RouteErrorBoundary() {
  const error = useRouteError();
  const location = useLocation();
  const message = extractErrorMessage(error);
  const isAdminArea = location.pathname.startsWith("/admin");
  const newDesign = isAdminArea ? isNewDesign() : isAssetFrontendNewDesign();

  if (newDesign) {
    return <NewDesignErrorPage message={message} />
  }
  return <ErrorPage message={message} />
};

